import * as constantModalActions from 'actions/constantsModal';
import * as flowBlockInput from 'actions/flowBlockInput';
import { stringCompare } from '@xmatters/common/utils/string';

const initialState = {
  constants: [],
  isNew: false,
  selectedConstant: null,
  show: false,
  usage: null,
};

const defaultData = {
  name: '',
  description: '',
  value: '',
};

function remove(constants, deleted) {
  return constants.filter(c => c.id !== deleted.id);
}

function isEmpty(constants) {
  return (constants || []).length === 0;
}

function sortConstants(toSort) {
  return toSort.sort((c1, c2) => stringCompare(c1.name, c2.name));
}

export default function constantsModal(state = initialState, action) {
  switch (action.type) {
    case constantModalActions.CONSTANTS_MODAL_SHOW: {
      return {
        ...state,
        // select the first one if there is one
        selectedConstant:
          state.constants.length > 0 ? state.constants[0] : null,
        show: true,
      };
    }
    case constantModalActions.CONSTANTS_MODAL_HIDE:
      return {
        ...state,
        show: false,
        isNew: false,
      };
    case constantModalActions.SINGLE_CONSTANT_LOAD_SUCCESS: {
      // load contains the usage
      return {
        ...state,
        selectedConstant: action.payload,
        constants: state.constants.map(c =>
          c.id === action.payload.id ? action.payload : c,
        ),
      };
    }
    case constantModalActions.CONSTANT_SAVE_SUCCESS: {
      if (state.isNew) {
        return {
          ...state,
          isNew: false,
          selectedConstant: action.payload,
          constants: sortConstants([action.payload, ...state.constants]),
        };
      }
      // the newly saved constant does not contain the usage
      const updated = sortConstants(
        state.constants.map(c =>
          c.id === action.payload.id
            ? { ...action.payload, usage: c.usage }
            : c,
        ),
      );
      return {
        ...state,
        selectedConstant: updated.find(
          c => c.id === (state.selectedConstant || {}).id,
        ),
        constants: updated,
      };
    }
    case constantModalActions.CONSTANT_SAVE_FAIL: {
      return {
        ...state,
        isNew: false,
      };
    }
    case constantModalActions.WORKFLOW_CONSTANTS_FETCH_PLAN_CONSTANTS_SUCCESS:
    case flowBlockInput.FBI_FETCH_PLAN_CONSTANT_SUCCESS:
      // will handle all constants fetches
      return {
        ...state,
        constants: sortConstants(action.payload.data),
      };
    case constantModalActions.CONSTANT_CREATE:
      return {
        ...state,
        selectedConstant: {
          ...defaultData,
          name: action.payload,
          isNew: true,
        },
        isNew: true,
      };
    case constantModalActions.CONSTANT_DELETE_SUCCESS: {
      const updated = remove(state.constants, action.payload);
      return {
        ...state,
        constants: updated,
        selectedConstant: isEmpty(updated) ? null : state.selectedConstant,
      };
    }
    case constantModalActions.CONSTANT_DELETE_NEW:
      return {
        ...state,
        isNew: false,
        selectedConstant: isEmpty(state.constants)
          ? null
          : state.selectedConstant,
      };
    default:
      return state;
  }
}
